import { SocketProvider } from "../../contexts/SocketContext";
import { Outlet } from "react-router-dom";

const SocketWrapper = () => {
  return (
    <SocketProvider>
      <Outlet />
    </SocketProvider>
  );
};

export default SocketWrapper;
